import { colors as c } from '@ui/colors'
import { StatusColors } from '@ui/elements/Status/types'
import { OptionColor } from '@order/steps/types'

export const colorOptionToColors: Record<OptionColor, StatusColors> = {
  default: { front: c.text, back: c.text25 },
  gray: { front: c.gray[600], back: c.gray[200] },
  latte: { front: c.latte[600], back: c.latte[200] },
  green: { front: c.lime[600], back: c.lime[200] },
  magenta: { front: c.magenta[600], back: c.magenta[100] },
  blue: { front: c.blue[600], back: c.blue[200] },
  bronze: { front: c.white, back: c.tgbo.bronze1 },
  silver: { front: c.white, back: c.tgbo.silver1 },
  gold: { front: c.white, back: c.tgbo.gold1 },
}
